import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {TabsetComponent} from 'ngx-bootstrap/tabs';

@Component({
    selector: 'app-contactTheAssessor',
    templateUrl: './contactTheAssessor.component.html',
    styleUrls: ['./contactTheAssessor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactTheAssessorComponent implements OnInit, AfterViewInit {
  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id = 0;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
    this.id = tabId + 1;
  }

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id || null;
   }

  ngAfterViewInit() {
    if(this.id !== null)
      this.selectTab(this.id -1);
  }

  ngOnInit() {
  }

}
